import axios from "axios";

const ROOT_URL = "https://apis.voicebase.com/";

export default (token, mediaId, baseUrl = "v3", accountId) => {
  if (!/^http/.test(baseUrl)) {
    baseUrl = ROOT_URL + baseUrl;
  }
  const url = `${baseUrl}/media/${mediaId}`;
  const metricsUrl = `${baseUrl}/definition/metrics`;

  const mediaPromise = axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(accountId && { "VoiceBase-Account-ID": accountId }),
    },
  });

  const metricsPromise = axios.get(metricsUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(accountId && { "VoiceBase-Account-ID": accountId }),
    },
  });

  return Promise.allSettled([mediaPromise, metricsPromise]).then((response) => {
    let metricGroups = [];
    if (response[0].status === "rejected") {
      throw response[0].reason;
    }

    if (response[1].status === "fulfilled") {
      metricGroups = response[1].value.data.metricGroups;
    }

    return {
      ...response[0].value.data,
      metricGroups,
    };
  });
};
